import axios from 'axios';

export function getSubdomain() {
  const { hostname } = window.location;
  const subdomain = hostname.split('.')[0];
  return subdomain.includes('localhost') ? 'school1' : subdomain;
}

export const axiosInstance = axios.create();

export const axiosAuthInstance = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}/api`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

function setupInterceptors() {
  // Request interceptor
  axiosAuthInstance.interceptors.request.use(
    config => {
      const token = localStorage.getItem('access_token') || '';
      if (token) {
        config.headers['token'] = token;
      }
      config.headers['subdomain'] = getSubdomain();
      return config;
    },
    error => Promise.reject(error)
  );

  // Response interceptor
  axiosAuthInstance.interceptors.response.use(
    response => response,
    async error => {
      const originalRequest = error.config;

      console.log({ error }, 'this is data');

      // Handle 401 error and refresh token if possible
      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;

        try {
          const refresh_token = localStorage.getItem('refresh_token');
          if (!refresh_token) {
            throw new Error('No refresh token found');
          }

          const response = await axios.post(
            `${process.env.REACT_APP_BASE_URL}/api/token/refresh/?refresh_token=${refresh_token}`,
            {}, // send empty body
            {
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                subdomain: getSubdomain(),
              },
            }
          );

          const newAccessToken = response.data.data.access_token;
          localStorage.setItem('access_token', newAccessToken);

          // Update the original request with new token
          originalRequest.headers['token'] = newAccessToken;

          // Retry the original request
          return axiosAuthInstance(originalRequest);
        } catch (refreshError) {
          console.error('Token refresh failed:', refreshError);
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          window.location.href = '/login';
          return Promise.reject(refreshError);
        }
      }

      return Promise.reject(error);
    }
  );
}

setupInterceptors();
export default axiosAuthInstance;
